module.exports = __webpack_public_path__ + "static/img/email-icon.3728026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/email-icon.png
// module id = /eIY
// module chunks = 0